import React from "react";
import { string, any, bool, func } from "prop-types";
import { Link } from "@quintype/components";

import { SvgIconHandler } from "../SvgIconHandler";

import "./Button.m.css";

const Button = ({
  href,
  children,
  socialButton,
  ariaLabel,
  customStyleName,
  iconType,
  iconWidth,
  iconHeight,
  onClickFunction,
  disableAjaxLinks = true,
  isEventConfigured = false,
  openInNewTab = false,
}) => {
  const buttonContent = iconType ? (
    <span styleName="button-content">
      <SvgIconHandler
        type={iconType}
        width={iconWidth}
        height={iconHeight}
        viewBox={`0 0 ${iconWidth} ${iconHeight}`}
      />
      {children}
    </span>
  ) : (
    children
  );

  if (socialButton) {
    return (
      <a href={href} styleName={`btn ${customStyleName}`} aria-label={ariaLabel} onClick={onClickFunction}>
        {children}
      </a>
    );
  }
  return href ? (
    isEventConfigured ? (
      <Link
        href={href}
        className="button"
        styleName={`btn ${customStyleName}`}
        aria-label={ariaLabel}
        disableAjaxLinks={disableAjaxLinks}
        onMouseDown={onClickFunction}
        onTouchStart={onClickFunction}
        target={openInNewTab ? "_blank" : "_self"}
      >
        {buttonContent}
      </Link>
    ) : (
      <Link
        href={href}
        className="button"
        styleName={`btn ${customStyleName}`}
        aria-label={ariaLabel}
        disableAjaxLinks={disableAjaxLinks}
        target={openInNewTab ? "_blank" : "_self"}
      >
        {buttonContent}
      </Link>
    )
  ) : (
    <button className="button" styleName={`btn ${customStyleName}`} aria-label={ariaLabel} onClick={onClickFunction}>
      {buttonContent}
    </button>
  );
};

Button.defaultProps = {
  href: "",
  children: "",
  socialButton: false,
  ariaLabel: "button",
  customStyleName: "",
  iconType: "",
  iconWidth: "16",
  iconHeight: "16",
  onClickFunction: () => {},
};

Button.propTypes = {
  href: string,
  children: any,
  socialButton: bool,
  ariaLabel: string.isRequired,
  customStyleName: string,
  iconType: string,
  iconWidth: string,
  iconHeight: string,
  onClickFunction: func,
  disableAjaxLinks: bool,
};

export default Button;
